import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'redux-form';
import { getClassName, checkButtonDisabled } from '../../utils/forms';
import countryList from '../../utils/country_list';
import InputField from '../shared/InputField';
import { toIdString } from '../../utils/common';

const FORM_ID = 'createAccountForm';

export default class AccountForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    initialValues: PropTypes.object,
    isEdit: PropTypes.bool,
    submitAccountFunction: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    isEdit: false,
    initialValues: null,
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit = params => {
    const { submitAccountFunction } = this.props;
    submitAccountFunction(params);
  };

  renderGenericSelectField = ({ input, label, meta: { touched, error } }) => (
    <div className={getClassName(touched, error)}>
      <label htmlFor={toIdString(label)} className="form-control-label">
        {label} {touched && error && <span> | {error} </span>}
      </label>
      <div className="form-group row">
        <div className="col-md-10">{this.renderSelect(input, label)}</div>
      </div>
    </div>
  );

  renderSelect = (input, label) => {
    if (label === 'Status') {
      return (
        <select {...input} id={toIdString(label)}>
          <option value="1">Enabled</option>
          <option value="0">Disabled</option>
        </select>
      );
    } else if (label === 'Account Type ID') {
      return (
        <select {...input} id={toIdString(label)}>
          <option value="2">Data Provider</option>
        </select>
      );
    } else if (label === 'Country') {
      return (
        <select {...input} id={toIdString(label)}>
          <option />
          {countryList.map(this.renderCountries)}
        </select>
      );
    }
    return null;
  };

  renderCountries = country => (
    <option key={country.key} value={country.name}>
      {country.name}
    </option>
  );

  renderCheckbox = ({ input, type, label, meta: { touched, error } }) => (
    <div className={getClassName(touched, error)}>
      <label htmlFor={toIdString(label)} className="form-control-label">
        {label} {touched && error && <span className="error">| {error}</span>}
      </label>
      <br />
      <input {...input} id={toIdString(label)} type={type} />
    </div>
  );

  render() {
    const { invalid, handleSubmit, isEdit, submitting } = this.props;

    return (
      <Form id={FORM_ID} onSubmit={handleSubmit(this.submit)}>
        <fieldset>
          <Field
            name="companyName"
            type="text"
            component={InputField}
            label="Company Name"
            placeholder="DataCo"
            maxLength="40"
            autoFocus
          />
          <div className="form-group row">
            <div className="col-xs-6">
              <Field name="status" component={this.renderGenericSelectField} label="Status" />
            </div>
            <div className="col-xs-6">
              <Field
                name="accountTypeId"
                component={this.renderGenericSelectField}
                label="Account Type ID"
              />
            </div>
          </div>
          <Field
            name="creditsEnabled"
            type="checkbox"
            component={this.renderCheckbox}
            label="Credits Enabled"
          />
          <Field
            name="address1"
            type="text"
            component={InputField}
            label="Address Line 1"
            placeholder="Address Line 1"
            maxLength="80"
          />
          <Field
            name="address2"
            type="text"
            component={InputField}
            label="Address Line 2"
            placeholder="Address Line 2"
            maxLength="80"
          />
          <Field
            name="city"
            type="text"
            component={InputField}
            label="City"
            placeholder="City"
            maxLength="40"
          />
          <Field
            name="stateProvince"
            type="text"
            component={InputField}
            label="State/Province"
            placeholder="State/Province"
            maxLength="80"
          />
          <Field
            name="postcode"
            type="text"
            component={InputField}
            label="Postal Code"
            placeholder="Postal Code"
            maxLength="10"
            minLength="5"
          />
          <Field name="country" component={this.renderGenericSelectField} label="Country" />
          <Field
            name="url"
            type="text"
            component={InputField}
            label="URL"
            placeholder="http://www.datarista.com"
            maxLength="80"
          />
          <Field
            name="portalHost"
            type="text"
            component={InputField}
            label="Portal Host"
            placeholder="dev.datarista.net"
            maxLength="80"
          />
          <Field
            name="phone"
            type="text"
            component={InputField}
            label="Phone Number"
            placeholder="(    ) ___-____ ext ___"
            maxLength="20"
            minLength="5"
          />
        </fieldset>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={checkButtonDisabled(invalid, submitting)}
        >
          {isEdit ? 'Update' : 'Create'} Account
        </button>
      </Form>
    );
  }
}
